import type { Action } from 'vuex'
import type { State } from '.'
import type { UseStorage } from '@/hooks/core/useStorage'
import type { CodesDetail, ProductParams } from '@/api/model/basicTypes'

import { actionTypes } from '.'
import usePageData, { Feature, PageCode } from '@/hooks/core/usePageData'
import useStorage from '@/hooks/core/useStorage'
import { CodesEnum } from '@/enums/codesEnum'

const { savePageData } = usePageData()

const initializationFactory = <T = any>(data: T): void =>
  savePageData<T>(PageCode.PRODUCT_LIST, Feature.INITIALIZATION, data)

export default <{ [actionType: string]: Action<State, any> }>{
  [actionTypes.SET_FOLDER_NAME]({ commit }, value: string): void {
    initializationFactory({ folderName: value })
    commit(actionTypes.SET_FOLDER_NAME, value)
  },

  [actionTypes.SET_FILE_NAME]({ commit }, value: string): void {
    initializationFactory({ fileName: value })
    commit(actionTypes.SET_FILE_NAME, value)
  },

  [actionTypes.SET_DOCUMENT_TYPE_INFO]({ commit }): void {
    const { loadCodesInformation }: UseStorage = useStorage()
    const codes: CodesDetail[] | undefined = loadCodesInformation()

    if (!codes) {
      return
    }

    const info = codes.find(
      (item: CodesDetail) => item.management_number === CodesEnum.DOCUMENT_TYPE
    ) as CodesDetail

    commit(actionTypes.SET_DOCUMENT_TYPE_INFO, info)
  },

  [actionTypes.SET_DOCUMENT_TYPE]({ commit }, value: string) {
    initializationFactory({ productType: value })
    commit(actionTypes.SET_DOCUMENT_TYPE, value)
  },
  [actionTypes.SET_PRODUCT_TABLE]: ({ commit }, data: any): void => {
    commit(actionTypes.SET_PRODUCT_TABLE, data)
  },

  // 商品一覧画面・検索条件
  [actionTypes.SET_PRODUCT_LIST_PARAM]: ({ commit }, data: ProductParams): void => {
    commit(actionTypes.SET_PRODUCT_LIST_PARAM, data)
  },
}
